<template>
  <page v-if="form" :back-to="getPreviousUrl" title="Edit Feed" size="is-tablet">
    <div slot="page-header-right">
      <button
        v-if="feed.data.pin"
        @click="unpin"
        class="button is-outlined is-danger"
        :class="{ 'is-loading': unpinForm.processing }"
      >
        Unpin
      </button>

      <modal-opener
        v-else
        :component="require('./PinFeedModal').default"
        :props="{ feedId: feed.data.id, whenPinned }"
      >
        <button slot="trigger" class="button is-outlined is-primary">
          Pin
        </button>
      </modal-opener>

      <button @click="destroy" class="button is-danger is-outlined">
        Delete
      </button>

      <publish
        v-model="form.published"
        :uri="`/admin/api/published/feed/${$route.params.id}`"
      ></publish>
    </div>

    <form @submit.prevent="update">
      <div class="box">
        <b-field label="Language">
          <b-select v-model="form.locale">
            <option :value="key" v-for="(label, key) in languages" :key="key">
              {{ label }}
            </option>
          </b-select>
        </b-field>

        <b-field label="Title">
          <b-input
            type="text"
            v-model="form.title"
            placeholder="Feed Title"
          ></b-input>
        </b-field>

        <b-field label="Link">
          <b-input type="text" v-model="form.link" placeholder="link"></b-input>
        </b-field>

        <b-field label="Description">
          <textarea class="textarea" v-model="form.description"></textarea>
        </b-field>

        <div class="columns">
          <div class="column is-6">
            <b-field label="Issue">
              <b-input
                type="text"
                v-model="form.issue_id"
                placeholder="Issue ID"
              ></b-input>
            </b-field>
          </div>

          <div class="column is-6">
            <b-field label="Page">
              <b-input
                type="text"
                v-model="form.page"
                placeholder="Page"
              ></b-input>
            </b-field>
          </div>
        </div>

          <div class="columns">
            <div class="column">
              <b-field label="Start Date">
                <datetimepicker v-model="form.starts_at"></datetimepicker>
              </b-field>
            </div>

            <div class="column">
              <b-field label="End Date">
                <datetimepicker v-model="form.ends_at"></datetimepicker>
              </b-field>
            </div>
          </div>
      </div>

      <div class="box">
        <p class="title is-5">Images</p>

        <div class="columns">
          <div class="column is-4">
            <div class="mb-4">
              <upload-image
                ref="uploadImage"
                file-field-name="file"
                :endpoint="$store.getters.kytebaseMediaUploadUrl"
                :additional="{ collection: 'images' }"
                @uploaded="(image) => (form.cover_path = image.path)"
              >
                <button
                  type="button"
                  slot="trigger"
                  class="button is-outlined is-primary is-small"
                >
                  Upload Cover
                </button>
              </upload-image>
            </div>

            <img
              v-if="form.cover_path"
              :src="feed.response.data.cdn_url + '/' + form.cover_path.trim('/')"
            />
          </div>

          <div class="column is-4">
            <div class="mb-4">
              <upload-image
                ref="uploadImage"
                file-field-name="file"
                :endpoint="$store.getters.kytebaseMediaUploadUrl"
                :additional="{ collection: 'images' }"
                croppable
                :croppie="{
                  aspectRatio: 1,
                  viewMode: 3,
                  autoCropArea: 1,
                }"
                @uploaded="whenBackgroundUploaded"
              >
                <button
                  type="button"
                  slot="trigger"
                  class="button is-outlined is-primary is-small"
                >
                  Upload Background
                </button>
              </upload-image>
            </div>

            <img
              v-if="form.background_path"
              :src="feed.response.data.cdn_url + '/' +form.background_path.trim('/')"
            />
          </div>
        </div>
      </div>

      <button
        type="submit"
        class="button is-primary"
        :class="{ 'is-loading': form.processing }"
      >
        Update Feed
      </button>

      <router-link to="/feeds" class="button is-white">Cancel</router-link>
    </form>
  </page>
</template>

<script>
import Publish from "./../../../../components/Publish";
import UploadImage from "./../../../../components/UploadImage";
import {getActiveLanguages} from "../../../../data/languages";

export default {
  components: {
    Publish,
    UploadImage,
  },

  data() {
    let languages = getActiveLanguages();

    return {
      publication: null,
      filteredTags: null,
      filter: null,
      isSelectOnly: false,
      page: null,
      feed: new window.RemoteData(`/admin/api/feeds/${this.$route.params.id}`),
      form: null,
      unpinForm: new window.Form(),
      tag: null,
      languages,
    };
  },

  watch: {
    publication() {
      this.buildLink();

      this.form.cover_path = this.publication.cover.original.replace(
        this.feed.response.data.cdn_url,
        ""
      );

      this.form.model_type = "publication";
      this.form.model_id = this.publication.id;
    },

    page() {
      this.buildLink();
    },
  },

  created() {
    this.feed.load(() => {
      this.form = new window.Form({
        title: this.feed.data.title,
        background_path: this.feed.data.background_path,
        cover_path: this.feed.data.cover_path,
        link: this.$store.state.config.app.dl + "://q?type=feed&id=" + this.feed.data.id,
        published: this.feed.data.published_at !== null,
        model_type: this.feed.data.model_type,
        model_id: this.feed.data.model_id,
        locale: this.feed.data.locale,
        issue_id: this.feed.data.issue ? this.feed.data.issue.id : null,
        starts_at: this.feed.data.starts_at,
        ends_at: this.feed.data.ends_at,
        page: this.feed.data.page,
        background_ratio: this.feed.data.background_ratio,
        description: this.feed.data.description
      });
    });
  },

  computed: {
    getPreviousUrl() {
      return localStorage.getItem('previous');
    },
  },

  methods: {
    buildLink() {
      this.form.link = this.$store.state.config.app.dl + `://q?type=publication&id=${this.publication.id}&page=${this.page}`;
    },

    update() {
      this.form
        .put(`/admin/api/feeds/${this.$route.params.id}`)
        .then(({message}) => {
          this.$buefy.toast.open(message);
        });

      this.$router.push("/feeds");
    },

    whenUploadedBackground(response) {
      this.form.background_path = response.path;
      this.form.background_ratio = response.ratio;
    },

    confirm(onConfirm) {
      this.$buefy.dialog.confirm({
        title: "Are you sure?",
        message:
          "You are deleting a feed. You cannot restore it when its deleted.",
        cancelText: "Cancel",
        confirmText: "Delete",
        type: "is-danger",
        hasIcon: true,
        onConfirm,
      });
    },

    destroy() {
      this.confirm(() => {
        this.$http
          .delete(`/admin/api/feeds/${this.feed.data.id}`)
          .then((response) => {
            this.$buefy.toast.open(response.data.message);
            this.$router.push("/feeds");
          })
          .catch((error) => {
            new window.FailedResponseHandler(error).handle();
          });
      });
    },
    whenPinned(pin) {
      this.feed.data.pin = pin;
    },
    unpin() {
      this.unpinForm
        .delete(`/admin/api/pinned-feeds/${this.feed.data.id}`)
        .then(({message}) => {
          this.$buefy.toast.open(message);
          this.feed.data.pin = null;
        });
    },

    whenBackgroundUploaded(image) {
      this.form.background_path = image.path;
      this.form.background_ratio = image.ratio;
    },
  },
};
</script>
